import React from 'react';
import { Route } from 'react-router';
import Admin from './screens/Admin/router';
import User from './screens/User/router';
export default (
  <Route path="companynews"
    getComponent={(location, cb) => {
      require.ensure([], (require) => {
        cb(null, require('./index'));
      });
    }}
  >
    {Admin}
    {User}
  </Route>
);



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/screens/Tube/screens/CompanyNews/router.js
 **/